/* eslint-disable react/no-array-index-key */

import type { ReactNode } from 'react';
import { useState } from 'react';
import { Button } from '@kcd/design-system';

import { chunk } from '~/utils/array';

import { ChevronDownOutlineIcon24x24 } from '~/assets/icons';

import styles from './index.module.css';

interface Props<T> {
  list: T[];
  columnCount?: number;
  rowCount?: number;
  renderToProduct: (product: T) => ReactNode;
}

const InfiniteSpreadhowcase = <T extends unknown>({
  list,
  columnCount = 3,
  rowCount = 2,
  renderToProduct,
}: Props<T>) => {
  const [currentIndex, setCurrentIndex] = useState(0);

  const offset = rowCount * columnCount;
  const chunkedList = chunk(list, offset); // [Array, Array, Array, ...]
  const endIndex = chunkedList.length - 1;

  const onClickMore = () => {
    setCurrentIndex((prev) => prev + 1);
  };

  return (
    <>
      {chunkedList.slice(0, currentIndex + 1).map((productList, index) => {
        const rows = chunk(productList, columnCount); // [Array, Array, ...]

        return (
          <div key={index}>
            {rows.map((row, rowIndex) => (
              <div className={styles.row} key={rowIndex}>
                {row.map((column, columnIndex) => {
                  const maxWidth = `${(100 / columnCount).toFixed(2)}%`;

                  return (
                    <div
                      style={{
                        maxWidth,
                      }}
                      key={columnIndex}
                    >
                      {renderToProduct(column)}
                    </div>
                  );
                })}
              </div>
            ))}
          </div>
        );
      })}
      {currentIndex !== endIndex && (
        <Button
          block
          variant="outline"
          size="md"
          onClick={onClickMore}
          className={styles.more}
        >
          <span>상품 더 보기</span>
          <ChevronDownOutlineIcon24x24 className="size-24" />
        </Button>
      )}
    </>
  );
};

export default InfiniteSpreadhowcase;
